import { render } from "./CuisineItemView.vue?vue&type=template&id=07361a27"
import script from "./CuisineItemView.vue?vue&type=script&lang=js"
export * from "./CuisineItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__